import Add from "../../table/Add";
import ApiService from "../../../services/apiService";
import {toast} from 'react-toastify'
import { useEffect,useState } from "react";
import { kmlTitle,addKml } from "../../../constants";
import CheckBoxs from "../../table/CheckBoxComponent";


const AddKml = () =>{
    
    const handleKml = async (data:any) =>{

        try{
             const response = await ApiService.axiosApi('/kml/addkml',{
                method : 'POST'
             })
            if(response.success){
                toast.success("Kml Added Successfully")
            }else{
                toast.error("Unable To Add Kml")
            }
        }catch(error){
           console.log(error);
           toast.error("Unable To Add Kml")
        }
    }

    return( 
        
         <CheckBoxs
            title={addKml}
            parentTitle={kmlTitle}
            onSubmit={handleKml}
            fields={[
                {
                    name: "file",
                    label: "Select Kml File",
                    type: "file",
                    validation: { required: "Chack Name is required" },
                    className: "form-control",
                    vaildation : {required : "File is required"}
                },
                {
                    name: "PlotOnMap",
                    label: "Plot On Map",
                    type: "checkbox",
                    validation: { required: "Chack Area is required" },
                    className: "form-check"
                    
                },
                
               
            ]} 
        /> 
        
        
    )
}

export default AddKml;